var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.50024C24 6.82524 20.0344 11.2268 14.8969 11.9065C14.5641 9.40337 13.4625 7.14399 11.8359 5.37681C13.6313 2.17056 17.0625 0.000244141 21 0.000244141H22.5C23.3297 0.000244141 24 0.670557 24 1.50024ZM0 4.50024C0 3.67056 0.670312 3.00024 1.5 3.00024H3C8.79844 3.00024 13.5 7.70181 13.5 13.5002V15.0002V22.5002C13.5 23.3299 12.8297 24.0002 12 24.0002C11.1703 24.0002 10.5 23.3299 10.5 22.5002V15.0002C4.70156 15.0002 0 10.2987 0 4.50024Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeed);
export default __webpack_public_path__ + "static/media/seed.88f8495bcf1ce8f96b07f8a6bf22c163.svg";
export { ForwardRef as ReactComponent };